import {useLayoutEffect, useRef} from 'react'
import useRouter, {useHistory} from './useRouter'
import {copyLocationParam, getRouteSearchParams} from "../../envs/_current/history";

export const useRouterSearchParam = ({}) => {
    const history = useHistory();

    const onChangeSearchParam = (name, value, action = 'push') => {
        const searchParams = getRouteSearchParams();
        searchParams.set(name, value);
        if (action === "push") {
            history.push({
                ...copyLocationParam(window.location ?? {}),
                pathname: window.location.pathname,
                search: '?' + searchParams.toString(),
            })
        } else {
            history.replace({
                ...copyLocationParam(window.location ?? {}),
                pathname: window.location.pathname,
                search: '?' + searchParams.toString(),
            })
        }
    }
    const onChangeSearchParams = (values, action = 'push') => {
        const searchParams = getRouteSearchParams();
        Object.entries(values).forEach(([name, value]) => {
            searchParams.set(name, value);
        });
        if (action === "push") {
            history.push({
                ...copyLocationParam(window.location ?? {}),
                pathname: window.location.pathname,
                search: '?' + searchParams.toString(),
            })
        } else {
            history.replace({
                ...copyLocationParam(window.location ?? {}),
                pathname: window.location.pathname,
                search: '?' + searchParams.toString(),
            })
        }
    }

    return {
        onChangeSearchParam,
        onChangeSearchParams
    }
}

const useOnLocationChange = callback => {
    const countRef = useRef(0)
    const {location} = useRouter()
    useLayoutEffect(() => {
        if (countRef.current) {
            callback()
        }
        countRef.current =
            countRef.current + 1
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])
}
export default useOnLocationChange
